import shopifySparkGenericDefaults from '../shopify-spark-generic/config.js';

function InitFunc() {
  shopifySparkGenericDefaults?.InitFunc?.();

  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers')) {
    const unwantedPageWrappers = [['.page .page__rte', 'rte']];

    unwantedPageWrappers.forEach(([elemSelector, className]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(className);
    });
  }
}

export default {
  includes: ['shopify-spark-generic'],
  ...shopifySparkGenericDefaults,
  InitFunc,
  Widgets: [
    ...shopifySparkGenericDefaults.Widgets.filter(
      (w) => !['SearchBox', 'SearchBoxDialogButton'].includes(w.name),
    ),
    {
      ...shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'SearchBox'),
      location: { selector: '#cm-search-box', class: 'cm-search-box' },
    },
    {
      ...shopifySparkGenericDefaults.Widgets.find((w) => w.name === 'SearchBoxDialogButton'),
      location: '#cm-mobile-search-box',
    },
  ],
};
